import React, { useState, useEffect } from 'react';
import AdminLayout from '../../components/admin/AdminLayout';
import AssemblyManager from '../../components/assembly/AssemblyManager';
import { useAssembly } from '../../context/AssemblyContext';
import { Assembly } from '../../types/assembly';
import { assemblyService } from '../../services/assemblyService';

const AdminAssembliesPage: React.FC = () => {
  const { joinAssembly: joinAssemblyContext } = useAssembly();
  const [selectedAssembly, setSelectedAssembly] = useState<Assembly | null>(null);

  // ✅ Restaurar asamblea seleccionada al recargar (solo durante sesión activa)
  useEffect(() => {
    const restoreSelectedAssembly = async () => {
      const savedAssemblyId = localStorage.getItem('adminSelectedAssembly');
      if (savedAssemblyId) {
        try {
          const assembly = await assemblyService.getAssemblyById(savedAssemblyId);
          if (assembly) {
            setSelectedAssembly(assembly);
            await joinAssemblyContext(assembly.id);
            console.log('✅ Asamblea seleccionada restaurada:', assembly.id);
          } else {
            // Si la asamblea no existe, limpiar localStorage
            localStorage.removeItem('adminSelectedAssembly');
          }
        } catch (error) {
          console.error('Error restaurando asamblea seleccionada:', error);
          localStorage.removeItem('adminSelectedAssembly');
        }
      }
    };

    restoreSelectedAssembly();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleAssemblySelect = async (assembly: Assembly | null) => {
    setSelectedAssembly(assembly);
    
    if (!assembly) {
      localStorage.removeItem('adminSelectedAssembly');
      return;
    }
    
    try {
      await joinAssemblyContext(assembly.id);
      // ✅ Guardar asamblea seleccionada en localStorage
      localStorage.setItem('adminSelectedAssembly', assembly.id);
      console.log('✅ Asamblea seleccionada guardada:', assembly.id);
      // NO redirigir automáticamente - dejar que el usuario vea las opciones
      // navigate('/admin/dashboard');
    } catch (error) {
      console.error('Error al seleccionar asamblea:', error);
      localStorage.removeItem('adminSelectedAssembly');
    }
  };

  return (
    <AdminLayout>
      <div className="p-8">
        <div className="max-w-7xl mx-auto">
          {/* <div className="mb-6">
            <h1 className="text-3xl font-bold text-gray-900">Gestión de Asambleas</h1>
            <p className="text-gray-600 mt-2">
              Crea, edita y gestiona las asambleas. Selecciona una para ver las opciones disponibles.
            </p>
          </div> */}
          
          <AssemblyManager 
            onAssemblySelect={handleAssemblySelect} 
            selectedAssembly={selectedAssembly}
          />
        </div>
      </div>
    </AdminLayout>
  );
};

export default AdminAssembliesPage;
